import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { searchMulti } from '../../services/tmdbApi';
import MovieCard from '../../components/MovieCard';
import Spinner from '../../components/Spinner';
import ErrorMessage from '../../components/ErrorMessage';

const SearchPage = () => {
	const [searchParams] = useSearchParams();
	const query = searchParams.get('query');
	const [results, setResults] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		const fetchResults = async () => {
			if (!query) {
				setLoading(false);
				setResults([]); // Clear results if no query
				return;
			}

			setLoading(true);
			setError(null);
			try {
				const data = await searchMulti(query);
				setResults(data);
				setLoading(false);
			} catch (err) {
				console.error('Error fetching search results:')
				setError('Failed to fetch search results. Please try again.')
				setLoading(false);
			}
		};

		fetchResults();
	}, [query]); // Re-run effect if query changes

	return (
		<div className="page-container">
			<h1 className="page-heading">Search Results for "{query}"</h1>

			{loading && <Spinner />} {/* Use Spinner component */}
			{error && <ErrorMessage message={error} />} {/* Use ErrorMessage component */}
			
			{!loading && !error && results.length === 0 && (
				<div className="message" style={{textAlign: 'center'}}>
					No results found for "{query}". Try a different search!
				</div>
			)}

			<div className="card-grid">
				{results.map((item) => (
					<MovieCard key={item.id} movie={item} />
				))}
			</div>
		</div>
	);
}

export default SearchPage;